import React from 'react';
import { HomeContent } from './components/homeContent';
export default function HomePage(){
    return(
        <div className=''>
        <HomeContent/>
        </div>
    )
}